import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

class UpgradeProductOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			data: null,
			selectedItem: '',
			errorMessage: ''
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('UpgradeProductOverlayDialog');
		this.props.resetSelectedSKU && this.props.resetSelectedSKU();
    }
	// format up to 2 decimal
    formatNumber2Decimal(number) {
        number = (number)?number.trim().replace(/,/g,""):number;
        if(number) {
            number = number.replace("$","");
            number = "$"+parseFloat(number).toFixed(2);
            return number === "$0.00"?"--":number;
        } else {
            return "--";
        }
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
			showDialog: this.props.showDialog,
			data: this.props.upgradeSKUData
		})
	}
	handleUpgrade(event) {
		event.preventDefault();
		if(this.state.selectedItem === '') {
			this.setState({
				errorMessage: 'Please selected upgrade item.'
			})
		} else {
			this.props.handleUpgradeItem(_.find(this.state.data, ['item', this.state.selectedItem]));
		}
	}
	setUpgradeItem(event) {
		this.setState({
			selectedItem: event.target.value
		})
	}
    render() {
        return (
			<div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="upgradeProductOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <div className="push">
                        <h2 className="title">Upgrade</h2>
                        <p>Upgrade for: <b>{this.props.sku}</b></p>
                    </div>
					<p className="red bold">{this.state.errorMessage}</p>
					{this.state.data && this.state.data.length > 0
	                    ? <form className="upgradeProductForm" name="upgradeProductForm" id="upgradeProductForm" action="">
	                        <table className="dataTableType2 upgradeProductTable">
	                            <thead>
	                                <tr>
	                                    <th className="product">
	                                        Product
	                                    </th>
	                                    <th className="availability">
	                                        Availability
	                                    </th>
	                                    <th className="eta">
	                                        ETA
	                                    </th>
	                                    <th className="price">
	                                        Price <span className="unbold">(Each)</span>
	                                    </th>
	                                    <th className="select">
	                                        Select
	                                    </th>
	                              </tr>
	                            </thead>
	                            <tbody>
									{this.state.data && this.state.data.map((item, index) => {
										return <tr key={index}>
		                                    <td className="product">
		                                        <b>{item.item}</b><br />
		                                        {item.itemDescription}
		                                    </td>
		                                    <td className="availability">
		                                        {item.availability}
		                                    </td>
		                                    <td className="eta">
		                                        {item.eta && moment(item.eta).format('MM/DD/YY')}
		                                    </td>
		                                    <td className="price">
												{this.formatNumber2Decimal(item.originalPrice)}
		                                    </td>
		                                    <td className="select">
		                                        <input type="radio" name="upgrade_for_XXXXXXXXXXX" defaultValue={item.item} onClick={this.setUpgradeItem.bind(this)} />
		                                    </td>
		                                </tr>
									})}
	                            </tbody>
	                        </table>
	                        <div className="noButtonContainer">
	                            <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
	                        </div>
	                        <div className="yesButtonContainer">
								<a className="blueButton yesButton" onClick={this.handleUpgrade.bind(this)}>Upgrade</a>
	                        </div>
	                    </form>
						: <p className="bold red">No upgrade available for this item.</p>
					}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

UpgradeProductOverlayDialog = connect(mapStateToProps)(UpgradeProductOverlayDialog);
export default UpgradeProductOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/upgradeProductOverlayDialog.js